import PageBreadcrumbs from "@/components/PageBreadcrumbs";
import styles from "@/styles/Visitors.module.scss";
import { Suspense } from "react";
import { getAuthUser } from "@/lib/firebase";
import { Trans, useTranslation } from "react-i18next";
import { WELCOME_VISITORS_URL } from "@/lib";
import i18n from "@/i18n/config";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import {
  usePersonalVisitors,
  personPreregistrationOptions,
  personalVisitorsOptions,
} from "@/api";
import { Button, LoadingSpinner } from "@app-components";
import { PreregistrationBody } from "@/components/pre-registration/PreregistrationBody";
import { useWelcomeVisitAccess } from "@/hooks/useWelcomeVisitAccess";
import { Visitors } from "@/components/pre-registration/CombinedVisitorsAndPreregistration";
import { useLoggedInUser, useRouterStore } from "@/store/zustandStore";
import { useBuildingQuery } from "@/components/RouterSetup";

export const Route = createFileRoute("/_portal/visitors/")({
  component: VisitorsBody,
  loader: () => {
    const { queryClient, user } = useRouterStore.getState();
    if (!queryClient) return;
    if (!queryClient) return;
    queryClient.ensureQueryData(personalVisitorsOptions(user.userId));
    queryClient.ensureQueryData(
      personPreregistrationOptions(user.userId, "future"),
    );
  },
});

function VisitorsBody() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const authUser = getAuthUser();
  const { data: visitors } = usePersonalVisitors(authUser.uid);
  const { data: preregistrations } = useBuildingQuery(
    personPreregistrationOptions(authUser.uid, "future"),
  );
  const currentUser = useLoggedInUser();
  useWelcomeVisitAccess(currentUser.buildingTenantId);

  return (
    <>
      <PageBreadcrumbs
        levels={[{ label: t("PAGES.VISITORS.HEADER"), path: "/visitors" }]}
      />
      <div className="pageHeader">
        <h1>{t("PAGES.VISITORS.HEADER")}</h1>
        <p>
          <Trans i18nKey="PAGES.VISITORS.SUBHEADER">
            Text
            <a href={WELCOME_VISITORS_URL(i18n.language)} target="_blank"></a>.
          </Trans>
        </p>
      </div>
      <Suspense
        fallback={
          <div className="center">
            <LoadingSpinner />
          </div>
        }
      >
        <Visitors visitors={visitors} />
      </Suspense>

      <div className={styles.preregistrationSection}>
        <div className={`${styles.preregistrationContainer} pageHeader`}>
          <div>
            <h1>{t("PAGES.VISITORS.PREREGISTRATION")}</h1>
            <p>{t("PAGES.VISITORS.PREREGISTRATION_DESCRIPTION")}</p>
          </div>
          <Button
            icon="add"
            onClick={() => navigate({ to: "/visitors/preregistration" })}
          >
            {t("PAGES.VISITORS.CREATE_PREREGISTRATION")}
          </Button>
        </div>
        <Suspense
          fallback={
            <div className="center">
              <LoadingSpinner />
            </div>
          }
        >
          <PreregistrationBody preregistrations={preregistrations ?? []} />
        </Suspense>
      </div>
    </>
  );
}
